import { useMemo } from 'react'
import { useBranch } from './useBranch'
import type { BranchOption } from 'api/branches'

export function useBranchAware() {
 const { isGlobalView, isBranchView, selectedBranchId, selectedBranch, branches } = useBranch()

 return useMemo(() => ({
 isGlobalView,
 isBranchView,
 effectiveBranchId: isBranchView ? selectedBranchId : null,
 requiresBranchPicker: isGlobalView,
 selectedBranch,
 selectedBranchId,
 branches,
 branchOptions: branches.map((b: BranchOption) => ({ label: b.name, value: b.id })),
 }), [isGlobalView, isBranchView, selectedBranchId, selectedBranch, branches])
}
